import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";

export const GiftTeaser = () => (
  <section className="container-lux py-6" data-testid="gift-teaser">
    <div className="grid items-center gap-8 overflow-hidden rounded-3xl border border-gold/30 bg-cream-grad p-6 sm:p-10 lg:grid-cols-[1.2fr_1fr]">
      <div>
        <span className="eyebrow">Hediye Çeki</span>
        <h2 className="mt-4 text-2xl font-semibold leading-tight text-emerald-950 sm:text-3xl">Sevdiklerinize Huzur Hediye Edin</h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-ink/65">
          Doğum günü, yıl dönümü ya da Anneler Günü… Lunessa hediye çeki ile sevdiklerinize Sivas’ta unutulmaz bir masaj ve spa deneyimi armağan edin.
        </p>
        <Link to="/hediye-ceki" className="btn-emerald mt-7" data-testid="gift-teaser-btn">
          <Gift className="h-4 w-4" /> Hediye Çeki Oluştur <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="relative hidden h-full min-h-[220px] items-center justify-center lg:flex">
        <div className="absolute h-48 w-80 rotate-[-6deg] rounded-3xl bg-emerald-950/90 ring-1 ring-gold/40" />
        <div className="bg-emerald-grad relative flex h-48 w-80 rotate-[3deg] flex-col justify-between rounded-3xl p-6 text-white shadow-[0_30px_60px_-30px_rgba(2,44,34,0.7)] ring-1 ring-gold/60">
          <p className="text-[10px] tracking-[0.35em] text-gold-light/80">LUNESSA SPA &amp; MASAJ</p>
          <p className="text-2xl font-bold tracking-[0.12em] text-gold-light">HEDİYE ÇEKİ</p>
          <div className="h-px bg-gradient-to-r from-gold/70 to-transparent" />
          <p className="text-xs text-white/70">Sivas’ta Huzur ve Yenilenmenin Adresi</p>
        </div>
      </div>
    </div>
  </section>
);
